import angryImg from '../assets/reactions/angry.png';
import hahaImg from '../assets/reactions/haha.png';
import likeImg from '../assets/reactions/like.png';
import loveImg from '../assets/reactions/love.png';
import sadImg from '../assets/reactions/sad.png';
import wowImg from '../assets/reactions/wow.png';

// Reaction types and emojis mapping
export const QUICK_REACTIONS = [
  {
    type: 'love',
    emoji: '❤️',
    label: 'Love',
    image: loveImg,
  },
  {
    type: 'haha',
    emoji: '😂',
    label: 'Haha',
    image: hahaImg,
  },
  {
    type: 'wow',
    emoji: '😮',
    label: 'Wow',
    image: wowImg,
  },
  {
    type: 'sad',
    emoji: '😢',
    label: 'Sad',
    image: sadImg,
  },
  {
    type: 'angry',
    emoji: '😡',
    label: 'Angry',
    image: angryImg,
  },
  {
    type: 'like',
    emoji: '👍',
    label: 'Like',
    image: likeImg,
  },
];

export const REACTION_IMAGES = {
  love: loveImg,
  haha: hahaImg,
  wow: wowImg,
  sad: sadImg,
  angry: angryImg,
  like: likeImg,
};

export const REACTION_MAP = {
  love: '❤️',
  haha: '😂',
  wow: '😮',
  sad: '😢',
  angry: '😡',
  like: '👍',
};

export const emojiToType = (val) => {
  if (!val) return null;
  if (REACTION_MAP[val]) return val;
  const entry = Object.entries(REACTION_MAP).find(([, e]) => e === val);
  return entry ? entry[0] : null;
};

export const typeToEmoji = (type) => REACTION_MAP[type] || '👍';

export const normalizeReactions = (list) => {
  const arr = Array.isArray(list) ? list : [];
  return arr
    .map((r) => {
      const type = r?.type || emojiToType(r?.emoji) || r?.name || r?.value || r?.reaction || r?.kind || null;
      const emoji = r?.emoji || (type ? typeToEmoji(type) : null);
      const userId = r?.userId || r?.user?.id || r?.uid || r?.userID || r?.senderId || null;
      const user = r?.user || (userId ? { id: userId } : null);
      if (!userId || !emoji) return null;
      return { ...r, type, emoji, userId, user };
    })
    .filter(Boolean);
};
